<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'info']"/>
            </div>
            <h4 class="title">Infos clients</h4>
        </md-card-header>
        <md-card-content>
            <div>
                <span class="font-bold">Nom client : </span>
                <span class="text-info cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Client Details',  {id: client.id })">
                    {{ client.name }}
                </span>
            </div>
            <div>
                <span class="font-bold">Nom site : </span>
                <span class="text-info cursor-pointer hover:underline" @mousedown="goToRoute($event, 'Site Details', { id: client.id, idSite: site.id })">
                    {{ site.name }}
                </span>
            </div>
            <div>
                <span class="font-bold">Adresse : </span> {{ site.address ? site.address.addresses : 'Ø' }}
            </div>
            <div>
                <span class="font-bold">Code postal : </span> {{ site.address ? site.address.zip_code : 'Ø' }}
            </div>
            <div>
                <span class="font-bold">Ville : </span> {{ site.address ? site.address.city : 'Ø' }}
            </div>
            <div>
                <span class="font-bold">Carte : </span>
                <a v-if="site.address && site.address.geo_lat !== 'Ø' && site.address.geo_long !== 'Ø'"
                   class="text-info cursor-pointer hover:underline"
                   :href="'https://www.google.fr/maps/place/' + site.address.geo_lat + ',' + site.address.geo_long"
                   target="_blank">Voir</a>
                <span v-else>Indisponible</span>
            </div>
            <md-divider v-if="schedules.length > 0" class="mt-1 mb-1.5"></md-divider>
            <div>
                <span class="font-bold">Horaires d'intervention : </span>
                <template v-if="schedules.length > 0">
                    <site-schedules :schedules="schedules"></site-schedules>
                </template>
                <span v-else class="ml-1">Ø</span>
            </div>
            <md-divider v-if="schedules.length > 0" class="mb-1.5"></md-divider>
            <div>
                <span class="font-bold">Contacts RDV : </span>
                <contacts-list v-if="site.contacts" :contacts="contactsList('Contact RDV')"></contacts-list>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import ContactsList from "@/pages/Sites/Contacts/components/ContactsList";
import SiteSchedules from "@/pages/Sites/Informations/components/SiteSchedules";
import routerMixin from '@/mixins/router-mixin';

export default {
    name: "ClientInformations",
    components: {
        ContactsList, SiteSchedules
    },
    mixins: [routerMixin],
    props: {
        site: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            schedules: []
        };
    },
    methods: {
        dayOfWeek(dayNumber) {
            let weekdays = this.$moment.weekdays(true)
            return weekdays[dayNumber].charAt(0).toUpperCase() + weekdays[dayNumber].slice(1)
        },
        formatSchedules(data) {
            let schedules = []
            data.map(d => {
                let sameSchedule = schedules.filter(s => { return s.day_number === d.day_number })
                if(sameSchedule.length > 0) {
                    sameSchedule[0].schedules.push({
                        id: d.id,
                        start: d.start,
                        end: d.end
                    })
                } else {
                    let schedule = {
                        ...d,
                        schedules: [{
                            id: d.id,
                            start: d.start,
                            end: d.end
                        }]
                    }
                    schedules.push(schedule)
                }
            })
            return schedules
        },
        contactsList(type) {
            return this.site.contacts?.filter(contact => { return contact.pivot.type === type }) ?? []
        },
    },
    mounted() {
        this.schedules = this.formatSchedules(this.site.schedules)
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    #schedules.md-list {
        padding-bottom: 0;
        .md-list-item {
            margin-bottom: .15rem;
            margin-left: 0;

            .md-list-item-content {
                font-size: 14px;
                min-height: 18px;
                padding: 0;

                * {
                    width: unset;
                }

                .day {
                    font-weight: 500;
                }
            }
        }
    }

    .contacts.md-list {
        padding: 0;
        .md-list-item {
            margin-left: 0;

            &:last-child {
                margin-bottom: 0;
            }
            .md-list-item-container {
                .md-list-item-content {
                    padding: 0;
                    min-height: 15px;
                    .md-list-item-text {
                        position: relative;
                        font-size: .75rem;

                        &.justify-between {
                            justify-content: space-between !important;
                        }
                    }
                    .md-button {
                        width: auto;
                        .md-ripple {
                            padding: 0 8px;
                        }
                    }
                    .md-icon {
                        font-size: 0.875rem !important;
                        min-width: 0.875rem !important;
                        height: 0.875rem !important;
                    }
                }
            }
        }

        .md-icon-button {
            margin: 0;
            padding: 5px;
            height: 27px;
            min-width: 35px;
            width: auto;
            line-height: 27px;
            .md-icon {
                font-size: 0.875rem !important;
                min-width: 0.875rem !important;
                height: 0.875rem !important;
            }
        }
    }
}
</style>
